/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  ERC2981,
  ERC2981Interface,
} from "../../../../../@openzeppelin/contracts/token/common/ERC2981";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ERC2981__factory {
  static readonly abi = _abi;
  static createInterface(): ERC2981Interface {
    return new utils.Interface(_abi) as ERC2981Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC2981 {
    return new Contract(address, _abi, signerOrProvider) as ERC2981;
  }
}
